import { ApiClient } from '@webapp/core/services/ApiClient'
import { ReconcileSessionRepository } from './ReconcileSessionRepository'

export const reconcileSessionRepository = new ReconcileSessionRepository({
  httpClient: ApiClient,
})
